module.exports = __webpack_public_path__ + "media/images/riders/ELLEN_NOBLE-392b9870662307eaf87cc54e68223d67.png";